import { ApolloLink } from '@apollo/client'
import { ApolloClient as RSCApolloClient, InMemoryCache as RSCInMemoryCache } from '@apollo/experimental-nextjs-app-support'

import { apolloCacheConfig, authLink, errorLink, httpLink } from './apollo.shared'

function getApolloBaseClient() {
  return new RSCApolloClient({
    cache: new RSCInMemoryCache(apolloCacheConfig),
    link: ApolloLink.from([
      authLink,
      httpLink,
      errorLink
    ]),
  })
}

export const makeApolloClient = getApolloBaseClient